import { render, staticRenderFns } from "./Proportion.vue?vue&type=template&id=ac71a84e&scoped=true&"
import script from "./Proportion.vue?vue&type=script&lang=js&"
export * from "./Proportion.vue?vue&type=script&lang=js&"
import style0 from "./Proportion.vue?vue&type=style&index=0&id=ac71a84e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac71a84e",
  null
  
)

export default component.exports